import { LoadingOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import fieldsValidator from 'library/helpers/validators/fieldsValidator';
import { useManagePermittedRoles } from 'library/hooks';
import _ from 'lodash';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectWorkspaceByID } from 'reduxStore/organisations/selectors';
import { organisationActions } from 'reduxStore/organisations/slice';
import { Col, Form, Input, Row, Spin, Tooltip, Typography } from 'zui/Antd';
const { Text, Title } = Typography;

function GeneralSetting() {
	const {
		token: { marginMD, colorTextLabel }
	} = theme.useToken();

	const { orgID } = useSelector((state) => state.Auth.selectedProfile);
	const { updateOrganisationLoading, error: orgError } = useSelector((state) => state.Organisations);
	const organisations = useSelector((state) => selectWorkspaceByID(state, orgID));
	const dispatch = useDispatch();
	const [form] = Form.useForm();

	const canEditSettings = useManagePermittedRoles('editSettings');

	// Watch form values for changes
	const formValues = Form.useWatch([], form);
	const originalValues = { name: organisations?.name || '' };
	const hasChanges = !_.isEqual(formValues, originalValues);

	useEffect(() => {
		if (organisations?.name) {
			form.setFieldsValue({ name: organisations.name });
		}
	}, [organisations?.name, form]);

	// Reset form field to original value when API error occurs
	useEffect(() => {
		if (orgError && organisations?.name) {
			form.setFieldsValue({ name: organisations.name });
		}
	}, [orgError, organisations?.name, form]);

	const handleFinish = async (values) => {
		const trimmedName = values.name?.trim();
		if (trimmedName && trimmedName !== organisations?.name) {
			dispatch(organisationActions.updateOrganisation({ orgID, values: { name: trimmedName } }));
		}
	};

	const handleBlur = async () => {
		if (hasChanges && formValues?.name) {
			const currentValue = formValues.name?.trim();
			if (currentValue && currentValue !== organisations?.name) {
				try {
					await form.validateFields(['name']);
					handleFinish({ name: currentValue });
				} catch (error) {
					console.warn('Validation failed:', error);
				}
			}
		}
	};

	return (
		<Row style={{ marginBottom: marginMD }} gutter={[marginMD]} align='top'>
			<Col xs={24} md={16}>
				<Title level={5} style={{ margin: 0 }}>
					Organisation Name
				</Title>
				<Text style={{ color: colorTextLabel }}>Change your Organization's display name.</Text>
			</Col>
			<Col xs={24} md={8}>
				<Tooltip title={!canEditSettings ? "You don't have permission to edit settings" : ''}>
					<Form form={form} onFinish={handleFinish}>
						<Form.Item name='name' rules={fieldsValidator.Name} style={{ marginBottom: 0 }}>
							<Input
								placeholder='Enter organisation name'
								disabled={!canEditSettings || updateOrganisationLoading}
								onBlur={handleBlur}
								suffix={
									updateOrganisationLoading && (
										<Spin indicator={<LoadingOutlined spin />} size='small' />
									)
								}
							/>
						</Form.Item>
					</Form>
				</Tooltip>
			</Col>
		</Row>
	);
}

export default GeneralSetting;
